import React, { useState } from 'react'
import { useScrollPosition } from '@dustin-web/microsite-components/src/hooks/use-scroll-position'
import { scrollToTop } from '@dustin-web/microsite-components/src/utils/scroll-to-top'
import Icon from '@dustin-web/microsite-components/src/icon'

const ScrollToTopButton = () => {
  const [show, setShow] = useState(false)

  useScrollPosition(({ currPos }) => {
    const shouldShow = currPos.y < -500
    const rerenderNeeded = shouldShow !== show

    if (shouldShow && rerenderNeeded) {
      setShow(true)
    } else if (!shouldShow && rerenderNeeded) {
      setShow(false)
    }
  })

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    scrollToTop()
  }

  return (
    <>
      {show && (
        <a
          id="scroll-to-top-btn"
          href="#"
          className="c-scroll-to-top-btn"
          onClick={onClick}
          aria-label="Scroll to top">
          <Icon name="arrow-up" />
        </a>
      )}
    </>
  )
}

export default ScrollToTopButton
